import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";

import { ModalAbstractComponent } from "../modal-abstract.component";
import { DomSanitizer } from "@angular/platform-browser";
import { Bind } from "primeng/bind";
import { ButtonDirective } from "primeng/button";
import { Dialog } from "primeng/dialog";
import { SafeHtmlPipe } from "../../shared/html/safe-html.pipe";

@Component({
  selector: "app-alert",
  templateUrl: "./alert.component.html",
  styleUrls: ["./alert.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ButtonDirective, Bind, Dialog, SafeHtmlPipe],
})
export class AlertComponent
  extends ModalAbstractComponent<void>
  implements OnInit
{
  private sanitizer = inject(DomSanitizer);

  public message: string;
  public title: string;

  private lastActiveElement: HTMLElement;

  ngOnInit() {
    this.lastActiveElement = document.activeElement as HTMLElement;
  }

  public setMessage(message: string): void {
    this.message = message;
  }

  public setTitle(title: string): void {
    this.title = title;
  }

  public close() {
    super.close();

    if (this.lastActiveElement) {
      this.lastActiveElement.focus();
    }
  }
}
